import AbstractProvidedClass from "../shared/AbstractProvidedClass";
import DataTable from "./edit/Fields/DataTable";
import SimpleField from "./edit/Fields/SimpleField";

export default class SpeciesInfo extends AbstractProvidedClass {
    species = null;

    constructor(provider) {
        super(provider);

        this.container = this.p.createDiv().parent('#p5canvas')
            .style('width', '264px')
            .style('padding', '10px');
        this.reposition();

        this.fields = this.createFields();

        this.container.hide();
    }

    display() {
        if (!this.species) {
            return;
        }
        this.p.noStroke();
        this.p.fill(255);
        this.p.stroke(100);
        this.p.strokeWeight(1);

        this.p.beginShape();
        this.p.vertex(this.x, 0);
        // this.p.vertex(this.x, 30);
        // this.p.bezierVertex(this.x - this.labelWidth, 50, this.x, 50, this.x, 70);
        this.p.vertex(this.x, this.p.height + 1);
        this.p.vertex(this.p.width + 1, this.p.height + 1);
        this.p.vertex(this.p.width + 1, -1);
        this.p.vertex(this.x, -1);
        this.p.endShape();
    }

    setSpecies(species) {
        this.species = species;
        if (this.species) {
            this.fields.map((field) => field.populate(this.species));
            this.container.show();
        } else {
            this.container.hide();
        }
    }

    reposition() {
        this.x = this.sideBar.x - 300
        this.container.position(this.x, 0);
    }

    createFields() {
        return [
            SimpleField.setup(this.provider)
                .setType('h3')
                .style('margin', '0')
                .parent(this.container)
                .setPopulate((species, field) => field.html(species.name))
                .make(),
            SimpleField.setup(this.provider)
                .setType('h4')
                .setPopulate((species, field) => field.html(species.scientific_name))
                .parent(this.container)
                .make(),
            DataTable.setup(this.provider)
                .parent(this.container)
                .make(),
        ];
    }
}
